/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
export const EventToken = core.serialization.object({
    accountId: AccountId.optional(),
    subscribeKey: core.serialization.string().optional(),
    ttl: core.serialization.number().optional(),
    token: core.serialization.string().optional(),
});
